export default __webpack_public_path__ + "static/media/accepted-icon.63a6a8ad.svg";